import { isNil } from "lodash";
import { useRefreshBookingData } from "PFApp/booking/hooks/use_refresh_booking_data";
import { useSyncRows } from "PFApp/booking/parts/overview/use_sync_rows";
import { useCallback } from "react";

import { useBookingBarContext } from "../../booking_bar_provider";

type UseRefreshAfterUpdateReturn = {
  refresh: VoidFunction;
};

export const useRefreshAfterUpdate = (): UseRefreshAfterUpdateReturn => {
  const { booking } = useBookingBarContext();
  const refreshBookingData = useRefreshBookingData();
  const syncRows = useSyncRows();

  const refresh = useCallback(async () => {
    if (!booking) {
      return;
    }
    refreshBookingData({
      bookingIds: [booking.id],
      bookingGroupId: booking.booking_group_id,
      activityId: booking.activity?.id,
      profileId: booking.profile_id,
      refreshProfile: !isNil(booking.booking_template_id)
    });
    const parentActivityIds = booking.activity?.parent_activity?.id
      ? [booking.activity.parent_activity.id]
      : [];
    await syncRows({
      profileId: booking.profile_id,
      activityId: booking.activity?.id,
      parentActivityIds
    });
  }, [booking, refreshBookingData, syncRows]);

  return { refresh };
};
